import { args } from '../../../common/args';
export const onScreenSizeChange = {
  onScreenSizeChange: {
    args: {
      width: args.number()
    }
  }
};